module.exports = __webpack_public_path__ + "static/media/B8.808c4742.jpg";